<div class="progress-bar-square" data-cy="progress-bar-square">
  @for (rows of activeElements; track rows) {
    <div class="bundles-progress-bar-square-row">
      @for (lines of rows; track lines; let index = $index) {
        <div class="square" data-cy="square"
        [style.background-color]="retrieveSquareBackground(lines)"></div>
      }
    </div>
  }
</div>

